import { render, staticRenderFns } from "./_SelectSend.vue?vue&type=template&id=439bec37&"
import script from "./_SelectSend.vue?vue&type=script&lang=js&"
export * from "./_SelectSend.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports